define('all/player/player',['jquery', 'all/navigation', 'all/dialog', 'all/pretty-links', 'all/player/session'], function ($, navigation, dialog, prettyLinks, session) {
	'use strict';

	function doLogin() {
		$(function () {
			$('#cnt-login-bar').hide();
			$('#promotion').hide();
			$('#cnt-player-bar').show();
			$('#topMenuComeonShop').show();
			showNewPlayerPromotionPopup();
		});
	}

	function showNewPlayerPromotionPopup() {
		if ($.cookie('isNewPlayerPromotionPopupEnabled') === 'true') {
			$.removeCookie('isNewPlayerPromotionPopupEnabled', {path: '/'});
			var onCancel = function () {
				location.href = prettyLinks.getLink('MyPages', 'MyBonuses');
			};
			dialog.flow('NewPlayerPromotionPopup', {}, $.noop, onCancel, $.noop);
		}
	}

	function redirectIfBodyFrame() {
		if ($('#bodyframe').length > 0) {
			navigation.gotoLastProductPage();
		}
	}

	function showLogoutConfirmation() {
		var TWENTY_SECONDS = 20000;
		var timeoutReference = setTimeout(redirectIfBodyFrame, TWENTY_SECONDS);
		dialog.flow('LogoutPlayer', {}, $.noop, function(){
			clearTimeout(timeoutReference);
			redirectIfBodyFrame();
		});
	}

	function getRootDomain(){
		return location.href.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].replace('www.','');
	}

	// do not show normal logout confirmation when pushed.
	// CO-8883 Do not allow a user to be logged in on multiple browsers.
	// Do not log out the player from the browser whose logging call initiated the pushLogout call.
	function pushedLogout(title, heading, message, webSessionIdToKeep) {
		var sessionCookie = $.cookie('COOKIE_KJ_WEB_SESSION_UNIQUE_ID');

		if (typeof sessionCookie !== 'undefined' && sessionCookie !== webSessionIdToKeep) {
			$.removeCookie('COOKIE_KJ_WEB_SESSION_UNIQUE_ID', {path: '/'}); //Use to remove reference on server side
			var domain = getRootDomain();
			$.removeCookie('sessionId', {domain: domain, path: '/'});

			var data = {
				title: title,
				heading: heading,
				message: message
			};
			dialog.load('push', data, session.logout, navigation.gotoLastProductPage);
			doLogout();
		}
	}

	function playerLogout() {
		showLogoutConfirmation();
		scrollTo(0, 0);
		session.logout();
	}

	function doLogout() {
		$('#cnt-player-bar').hide();
        var loginBar = $('#cnt-login-bar');
        var rememberMe = $.cookie('PARAM_USER_NAME');
        if(!rememberMe){
            loginBar.find('#loginusername').val('');
        }
        loginBar.find('#loginpassword').val('');
        loginBar.show();
		$('#topMenuComeonShop').hide();
		$('#promotion').show();
	}

	$(session).on('login', doLogin);
	$(session).on('logout', doLogout);

	$(function () {
		if (session.authenticated) {
			doLogin();
		} else {
			doLogout();
		}
	});

	// TODO: javascript - pushedLogout called from PlayerInfo.swf when logging out someone via push
	window.player = {
		logout: playerLogout,
		pushedLogout: pushedLogout
	};

	return window.player;
});

